<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card>


          <v-data-table
              :headers="headers"
              :items="dataItems"
              :loading="loading"
              :search="search"
              :single-expand="true"
              class="elevation-1"
              item-key="_id"
              show-expand
              sort-by="calories"
          >
            <template v-slot:top>
              <v-toolbar
                  flat
              >
                <v-toolbar-title>
                  Employees
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    hide-details
                    label="Search Employee"
                    single-line
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog
                    v-model="dialog"
                    max-width="500px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-model="addEmployee"
                        v-bind="attrs"
                        v-on="on"
                        class="mb-2"
                        color="primary"
                        dark
                        @click="addEmployee = true"
                    >
                      New Employee
                    </v-btn>
                  </template>

                  <!--
                    Alerts & Loaders
                  -->
                  <Loader :loading="loadingCreateUpdateDelete"/>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" md="4" sm="6">
                            <div>
                              <v-text-field
                                  v-model="editedItem.employee_fullname"
                                  label="Name"
                                  @blur="$v.editedItem.employee_fullname.$touch()"
                              ></v-text-field>
                              <p v-if="!$v.editedItem.employee_fullname.maxLength" style="color: red;">Please provide a
                                valid
                                name within the range.</p>
                            </div>
                          </v-col>
                          <v-col cols="12" md="4" sm="6">
                            <div>
                              <v-text-field
                                  v-model="editedItem.employee_email"
                                  label="Email"
                                  @blur="$v.editedItem.employee_email.$touch()"
                              ></v-text-field>
                              <p v-if="!$v.editedItem.employee_email.email || !$v.editedItem.employee_email.wbst_suffix"
                                 style="color: red;">Please provide a valid email address.</p>
                            </div>
                          </v-col>
                          <v-col cols="12" md="4" sm="6">
                            <div>
                              <v-text-field
                                  v-model="editedItem.employee_phone"
                                  label="Phone Number"
                                  @blur="$v.editedItem.employee_phone.$touch()"
                              ></v-text-field>
                              <p v-if="!$v.editedItem.employee_phone.check_phone" style="color: red;">Phone number must
                                start
                                with 91,92,93 or 96.</p>
                              <p v-if="!$v.editedItem.employee_phone.numeric" style="color: red;">Phone number must a
                                numeric
                                value.</p>
                              <p v-if="!$v.editedItem.employee_phone.minLength || !$v.editedItem.employee_phone.maxLength"
                                 style="color: red;">Phone number must have 9 digits.</p>
                            </div>
                          </v-col>
                          <v-col cols="12" md="4" sm="6">
                            <div>
                              <v-menu
                                  ref="menuDate"
                                  v-model="menuDate"
                                  :close-on-content-click="false"
                                  max-width="290px"
                                  min-width="290px"
                                  offset-y
                                  transition="scale-transition"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                      v-model="dateFormatted"
                                      v-bind="attrs"
                                      v-on="on"
                                      hint="Format DD/MM/AAAA"
                                      label="Birthdate"
                                      persistent-hint
                                      prepend-icon="mdi-calendar"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="editedItem.employee_birthdate"
                                    no-title
                                    @blur="$v.editedItem.employee_birthdate.$touch()"
                                    @input="menuDate = false"
                                ></v-date-picker>
                              </v-menu>
                              <p v-if="!$v.editedItem.employee_birthdate.minVal || !$v.editedItem.employee_birthdate.maxVal"
                                 style="color: red;">You must be at least 18 years old to be a manager.</p>
                            </div>
                          </v-col>
                          <v-col cols="12" md="4" sm="6">
                            <div>
                              <v-text-field
                                  v-model="editedItem.employee_address"
                                  label="Morada"
                                  @blur="!$v.editedItem.employee_address.$touch()"
                              ></v-text-field>
                              <p v-if="!$v.editedItem.employee_address.maxLength" style="color: red;">Please provide a
                                valid
                                Address within the range.</p>
                            </div>
                          </v-col>
                          <v-col cols="12" md="4" sm="6">
                            <div>
                              <v-text-field
                                  v-model="editedItem.employee_job"
                                  label="Job"
                              ></v-text-field>

                            </div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                          color="blue darken-1"
                          text
                          @click="close"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                          :disabled="$v.$anyDirty && $v.$anyError"
                          color="blue darken-1"
                          text
                          @click="save"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="570px">
                  <v-card>
                    <v-card-title class="headline">Are you sure you want to remove this employee?</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>

                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon
                  class="mr-2"
                  small
                  @click="editItem(item)"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                  small
                  @click="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <!--TODO: estilizar melhor -->
                <p>
                  Address: {{ item.employee_details.address }}
                </p>
                <p>
                  Birthdate: {{ item.employee_details.birth | dateFormat }}
                </p>
                <p>
                  Job: {{ item.employee_details.job }}
                </p>
                <p>
                  Establishment: {{ item.employee_details.establishment }}
                </p>

              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {parse_employees} from "../../modules/utils";
import moment from 'moment'
import Loader from "../shared/Loader";
import VueNotifications from "vue-notifications";
import {
  manager_create_employee,
  manager_delete_employee,
  manager_get_all_employees,
  manager_update_employee
} from "../../modules/nite_api";
import {mapGetters} from "vuex";

import {required, email, helpers, minLength, maxLength, numeric} from 'vuelidate/lib/validators';

//Check if email contains .com or .net
const wbst_suffix = helpers.regex('alpha', /(\.com|\.net)$/);

//Check if the phone number start with 91,92,93,96 and has 9 elements
const check_phone = helpers.regex('numeric', /^(91|92|93|96)/);


export default {
  components: {
    Loader
  },
  data: () => ({
    response: null,
    loading: false,
    loadingCreateUpdateDelete: false,
    menuDate: false,
    dialog: false,
    dialogDelete: false,
    addEmployee: false,
    search: '',
    headers: [
      {
        text: 'Name',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {text: 'Email', value: 'email', sortable: false},
      {text: 'Phone Number', value: 'phone', sortable: false},
      {text: 'More', value: 'data-table-expand'},
      {text: 'Actions', value: 'actions', sortable: false},
    ],
    dataItems: [],
    editedItem: {
      employee_id: '',
      employee_fullname: '',
      employee_email: '',
      employee_phone: '',
      employee_birthdate: '',
      employee_address: '',
      employee_job: '',
      employee_establishment: '',

    },
    defaultItem: {
      employee_id: '',
      employee_fullname: '',
      employee_email: '',
      employee_phone: '',
      employee_birthdate: '',
      employee_address: '',
      employee_job: '',
      employee_establishment: '',

    },
  }),
  validations: {
    editedItem: {
      employee_phone: {
        required,
        numeric,
        check_phone,
        minLength: minLength(9),
        maxLength: maxLength(9)
      },
      employee_fullname: {
        required,
        maxLength: maxLength(45)
      },
      employee_birthdate: {
        required,
        minVal: value => value >= '01-01-1950',
        maxVal: value => value <= '31-12-2002'
      },
      employee_address: {
        required,
        maxLength: maxLength(100)
      },
      employee_establishment: {
        required
      },
      employee_email: {
        required,
        email,
        wbst_suffix
      },
      employee_job: {
        required
      }
    },
  },
  computed: {

    ...mapGetters({

      manager: 'auth/manager'

    }),

    formTitle() {
      return this.addEmployee === true ? 'New Employee' : 'Edit Employee'
    },
    dateFormatted() {
      return this.editedItem.employee_birthdate ? moment(this.editedItem.employee_birthdate).format('DD-MM-YYYY') : ''
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    },
    dateFormatted(val) {
      val || this.editedItem.employee_birthdate ? moment(this.editedItem.employee_birthdate).format('DD-MM-YYYY') : ''
    },

  },

  created() {
    this.getDataFromApi()
  },

  methods: {

    async getDataFromApi() {
      this.loading = true

      try {

        const response = await manager_get_all_employees()

        // Success
        console.log(response);
        this.dataItems = response.data.map(parse_employees);
        this.response = response.status;


      } catch (error) {
        // Error
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          console.log(error.response.data);
          console.log(error.response.status);
          this.response = error.response.status;

          console.log(error.response.headers);
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);
        } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);
        }
        console.log(error.config);
      } finally {
        this.loading = false;
        switch (this.response) {
          case 200:
            break;
          case 304:
            this.showWarnMsg({title: 'Oops', message: 'You didn\'t update nothing!'});
            break;
          case 400:
            this.showErrorMsg({
              title: 'Oops',
              message: 'Some field is missing or isn\'t correct. Please make the corrections and try again!'
            });
            break;
          case 401:
            this.showErrorMsg({title: 'Error', message: 'You aren\'t authorized to do that operation!'});
            break;
          case 404:
            this.showErrorMsg({title: 'Oops', message: 'The resource doesn\'t exist! Please try again!'});
            break;
          case 409:
            this.showErrorMsg({
              title: 'Oops',
              message: 'The resource that you were trying to add or update already exists! Please try again!'
            });
            break;
          case 500:
            this.showErrorMsg({
              title: 'Error',
              message: 'Something went wrong with the request. Please try again later!'
            });
            break;
          default:

            break;
        }


      }

    },
    async save() {

      this.editedItem.employee_establishment = this.manager.establishment

      let request_data = {
        "address": this.editedItem.employee_address,
        "birth": this.editedItem.employee_birthdate,
        "phone": this.editedItem.employee_phone,
        "name": this.editedItem.employee_fullname,
        "email": this.editedItem.employee_email,
        "job": this.editedItem.employee_job,
        "establishment": this.editedItem.employee_establishment,

      }
      this.loadingCreateUpdateDelete = true;
      if (this.addEmployee) {

        try {

          const response = await manager_create_employee(request_data);


          // Success
          console.log(response);
          this.response = response.status;

        } catch (error) {
          // Error
          if (error.response) {
            /*
             * The request was made and the server responded with a
             * status code that falls out of the range of 2xx
             */
            console.log(error.response.data);
            console.log(error.response.status);
            this.response = error.response.status;

            console.log(error.response.headers);
          } else if (error.request) {
            /*
             * The request was made but no response was received, `error.request`
             * is an instance of XMLHttpRequest in the browser and an instance
             * of http.ClientRequest in Node.js
             */
            console.log(error.request);
          } else {
            // Something happened in setting up the request and triggered an Error
            console.log('Error', error.message);
          }
          console.log(error.config);
        } finally {
          this.loadingCreateUpdateDelete = false;
          switch (this.response) {
            case 200:
              this.showSuccessMsg({title: 'Success', message: 'Employee added successfully!'});
              break;

            case 400:
              this.showErrorMsg({
                title: 'Oops',
                message: 'Some field is missing or isn\'t correct. Please make the corrections and try again!'
              });
              break;
            case 401:
              this.showErrorMsg({title: 'Error', message: 'You aren\'t authorized to do that operation!'});
              break;

            case 406:
              this.showErrorMsg({
                title: 'Oops',
                message: 'The employee email that you trying to add already exists! Please try again with other email!'
              });
              break;
            case 500:
              this.showErrorMsg({
                title: 'Error',
                message: 'Something went wrong with the request. Please try again later!'
              });
              break;
            default:
              break;
          }

        }


      } else {
        try {

          const response = await manager_update_employee(this.editedItem.employee_id, request_data);


          // Success
          console.log(response);
          this.response = response.status;

        } catch (error) {
          // Error
          if (error.response) {
            /*
             * The request was made and the server responded with a
             * status code that falls out of the range of 2xx
             */
            console.log(error.response.data);
            console.log(error.response.status);
            this.response = error.response.status;

            console.log(error.response.headers);
          } else if (error.request) {
            /*
             * The request was made but no response was received, `error.request`
             * is an instance of XMLHttpRequest in the browser and an instance
             * of http.ClientRequest in Node.js
             */
            console.log(error.request);
          } else {
            // Something happened in setting up the request and triggered an Error
            console.log('Error', error.message);
          }
          console.log(error.config);
        } finally {
          this.loadingCreateUpdateDelete = false;

          switch (this.response) {
            case 200:
              this.showSuccessMsg({title: 'Success', message: 'Employee updated successfully!'});
              break;
            case 304:
              this.showWarnMsg({title: 'Oops', message: 'You didn\'t update nothing!'});
              break;
            case 400:
              this.showErrorMsg({
                title: 'Oops',
                message: 'Some field is missing or isn\'t correct. Please make the corrections and try again!'
              });
              break;
            case 401:
              this.showErrorMsg({title: 'Error', message: 'You aren\'t authorized to do that operation!'});
              break;

            case 409:
              this.showErrorMsg({
                title: 'Oops',
                message: 'The employee email that you trying to edit already exists! Please try again with other email!'
              });
              break;
            case 500:
              this.showErrorMsg({
                title: 'Error',
                message: 'Something went wrong with the request. Please try again later!'
              });
              break;
            default:
              break;
          }


        }
      }


      this.close()
    },
    async deleteItemConfirm() {

      this.loadingCreateUpdateDelete = true;

      try {

        const response = await manager_delete_employee(this.editedItem.employee_id);


        // Success
        console.log(response);
        this.response = response.status;
      } catch (error) {
        // Error
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          console.log(error.response.data);
          console.log(error.response.status);
          this.response = error.response.status;
          console.log(error.response.headers);
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);
        } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);
        }
        console.log(error.config);
      } finally {
        this.loadingCreateUpdateDelete = false;
        switch (this.response) {
          case 200:
            this.showSuccessMsg({title: 'Success', message: 'Employee deleted successfully!'});
            break;

          case 400:
            this.showErrorMsg({
              title: 'Oops',
              message: 'The employee does not work at the establishment!'
            });
            break;
          case 401:
            this.showErrorMsg({title: 'Error', message: 'You aren\'t authorized to do that operation!'});
            break;
          case 500:
            this.showErrorMsg({
              title: 'Error',
              message: 'Something went wrong with the request. Please try again later!'
            });
            break;
          default:

            break;
        }

      }

      this.closeDelete()
    },
    editItem(item) {
      this.editedItem.employee_address = item.employee_details.address;
      this.editedItem.employee_birthdate = item.employee_details.birth;
      this.editedItem.employee_phone = item.phone;
      this.editedItem.employee_fullname = item.name;
      this.editedItem.employee_email = item.email;
      this.editedItem.employee_id = item._id;
      this.editedItem.employee_job = item.employee_details.job;


      this.dialog = true
    },
    deleteItem(item) {


      this.editedItem.employee_id = item._id;


      this.dialogDelete = true
    },
    close() {
      this.dialog = false

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
      })
      this.addEmployee = false
      this.getDataFromApi()

    },
    closeDelete() {
      this.dialogDelete = false

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
      })
      this.getDataFromApi()
    },



  },


  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: 'Hello there',
      message: 'That\'s the success!'
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: 'Hey you',
      message: 'Here is some info for you'
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: 'Wow, man',
      message: 'That\'s the kind of warning'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: 'Wow-wow',
      message: 'That\'s the error'
    }

  }
}
</script>